import StatusColumn from "widgets/grid/cells/StatusColumn";

const CREATIVE_NAME_COLUMN = {
	key: "filename",
	name: "Creative Name",
	width: 380,
};

const CREATIVE_ID_COLUMN = {
	key: "idCreative",
	name: "ID",
	width: 90,
	cellClass: "centered",
};

const CREATIVE_STATUS_COLUMN = {
	key: "approval",
	name: "Status",
	width: 232,
	cellClass: "centered",
	formatter: StatusColumn,
	getRowMetaData: () => ({}),
};

export const TOGGLE_AUTO_UPDATES_COLUMNS = [
	CREATIVE_NAME_COLUMN,
	CREATIVE_ID_COLUMN,
	CREATIVE_STATUS_COLUMN,
];
